/**
 * Copy the editor media % onto --media-pct (unitless) and --media-width (cqw)
 * so large-screen columns can lerp from the admin split to 864 / 820.
 */
(function () {
	'use strict';

	const SELECTOR = '.wp-block-media-text';

	function mediaPercent(gridTemplateColumns) {
		if (!gridTemplateColumns) {
			return 50;
		}

		const pct = String(gridTemplateColumns)
			.trim()
			.split(/\s+/)
			.find(function (part) {
				return part.indexOf('%') !== -1;
			});

		const value = pct ? parseFloat(pct) : 50;
		return Number.isFinite(value) ? value : 50;
	}

	function syncMediaWidth(el) {
		const pct = mediaPercent(el.style.gridTemplateColumns);
		const nextCqw = pct + 'cqw';
		const nextPct = String(pct);

		if (
			el.style.getPropertyValue('--media-width') === nextCqw &&
			el.style.getPropertyValue('--media-pct') === nextPct
		) {
			return;
		}

		el.style.setProperty('--media-width', nextCqw);
		el.style.setProperty('--media-pct', nextPct);
	}

	function syncTree(root) {
		if (!root || root.nodeType !== 1) {
			return;
		}

		if (root.matches && root.matches(SELECTOR)) {
			syncMediaWidth(root);
		}

		if (root.querySelectorAll) {
			root.querySelectorAll(SELECTOR).forEach(syncMediaWidth);
		}
	}

	function init() {
		syncTree(document.body);

		const observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				if (
					mutation.type === 'attributes' &&
					mutation.target.matches &&
					mutation.target.matches(SELECTOR)
				) {
					syncMediaWidth(mutation.target);
					return;
				}

				if (mutation.type === 'childList') {
					mutation.addedNodes.forEach(syncTree);
				}
			});
		});

		observer.observe(document.body, {
			subtree: true,
			childList: true,
			attributes: true,
			attributeFilter: ['style'],
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
